import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleSortService } from '../../services';

export const fetchModuleSort = createAsyncThunk(
    'moduleSort/fetchModuleSort',
    async ({ id, sort }) => {
        const response = await ModuleSortService(id, sort)
        return response.result
    }
)

const moduleSortSlice = createSlice({
    name: 'moduleSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleSortSlice.reducer;
